import type {ReactElement} from 'react';
import {PillButton} from '@Components/pill-button';
import {PillButtonSize} from '@Components/pill-button/pill-button.types';
import {TextSize} from '@Components/text';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import type {AiChatAssetsFiltersProps} from './ai-chat-assets-filters.types';
import {ASSET_FILTER_OPTIONS} from './ai-chat-assets-filters.types';

export function AiChatAssetsFilters({filter, onFilterChange}: AiChatAssetsFiltersProps): ReactElement {
  const {isSmall} = useAiChatSize();

  const getPillSize = (): PillButtonSize => {
    if (isSmall) {
      return PillButtonSize.SMALL;
    }

    return PillButtonSize.MEDIUM;
  };

  const getPillTextSize = (): TextSize => {
    if (isSmall) {
      return TextSize.SM;
    }

    return TextSize.MD;
  };

  return (
    <div className="flexbox gap-2">
      {ASSET_FILTER_OPTIONS.map((option) => (
        <PillButton
          key={option.filter}
          size={getPillSize()}
          textSize={getPillTextSize()}
          text={window.i18next.t(option.labelKey)}
          isSelected={option.filter === filter}
          retainSizeOnSelection
          onClick={(): void => {
            onFilterChange(option.filter);
          }}
        />
      ))}
    </div>
  );
}
